import { APIClient } from '@frontend/api-utils';
import { ProblemListResponse } from '@frontend/problem/types';

export class ProblemEquipmentClient extends APIClient {
    public static readonly endpoint = '/problem-api/v1';

    public static async fetchEquipmentProblems(accountId: string, equipmentId: string): Promise<ProblemListResponse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/problems`);
        return await this.handleResponse<ProblemListResponse>(response);
    }
}
